import { validateEnumTranslations } from '../../safety_checks';

/**
 * Intention captée à l'écran d'entrée de l'onboarding (Porte A) ou dérivée de la
 * qualification Pulse (Porte B). Personnalise la mise en scène du parcours et
 * l'encart adaptatif du tableau de bord. Cf. docs/onboarding.html § 01.
 */
export enum OnboardingIntention {
  RESERVATION = 'RESERVATION',
  SITE_VISIBILITE = 'SITE_VISIBILITE',
  LES_DEUX = 'LES_DEUX',
}

export const OnboardingIntentionTranslation = {
  'fr-FR': {
    [`${OnboardingIntention.RESERVATION}`]: 'Avoir un agenda de réservation',
    [`${OnboardingIntention.SITE_VISIBILITE}`]: 'Avoir un site avec référencement optimisé',
    [`${OnboardingIntention.LES_DEUX}`]: 'Les deux comptent autant',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(OnboardingIntention, OnboardingIntentionTranslation, '', true);
